<template>
    <div class="bar"><span>Phonetic Notation</span></div>
    <div class="notation-list">
        <div class="notation-item">
            <div class="phoneme">Phoneme</div>
            <div class="notation">Notation</div>
        </div>
        <template v-for="(irow, i) in comp.list" :key="i">
            <div class="notation-item">
                <ReumTextBox class="input-text phoneme" v-model="irow.phoneme" ></ReumTextBox>
                <ReumTextBox class="input-text notation" v-model="irow.mark"></ReumTextBox>
                <div class="btn-box">
                    <button class="btn btn-submit" @click="comp.doSubmit(irow)"><i class="las la-save"></i></button>
                    <!-- <button type="button" class="btn btn-del" @click="comp.doDelete(irow.idx)"><i class="lar la-trash-alt"></i></button> -->
                </div>
            </div>
        </template>
    </div>
</template>

<script>
import { reactive, onMounted } from "vue";
import axios from "axios";
import { useToast } from 'vue-toastification';
import ReumTextBox from "@/components/ReumLib/UI/ReumTextBox.vue";

export default {
    name: "Notation",
    props: {
        modelValue: String,
    },
    components: {
        ReumTextBox
    },
    setup() {
        const toast  = useToast();
        const comp = reactive({
            page : 1,
            list:[], total:0,
            selected: { idx:'', phoneme:'', notation:'' },

            doSearch: () => {
                let params = {
                    page : comp.page
                }
                axios.get("/ai/notation_list", { params:params }).then((res) => {
                    if( res.data.err == 0 ){
                        comp.list = res.data.list
                        comp.total = res.data.total
                    }
                })
            },

            onSelect:(s)=>{
                comp.selected.idx = s.idx
                comp.selected.phoneme = s.phoneme
                comp.selected.notation = s.notation
            },

            deSelect:()=>{
                comp.selected.idx = ''
                comp.selected.phoneme = ''
                comp.selected.notation = ''
            },

            addNew: () => {
                let params = {
                    idx : comp.selected.idx,
                    phoneme : comp.selected.phoneme,
                    notation : comp.selected.notation
                }
                if( !params.phoneme || !(params.phoneme.trim()) ){
                    toast.warning("발음을 입력해 주세요.")
                    return;
                }
                if( !params.notation || !(params.notation.trim()) ){
                    toast.warning("발음 표기를 입력해 주세요.")
                    return;
                }
                axios.post("/ai/notation_add", params).then((res) => {
                    if( res.data.err == 0 ){
                        comp.doSearch()
                        comp.doDeselect()
                    } else {
                        if( res.data.err_msg ) toast.error( res.data.err_msg )
                    }
                });
            },

            doSubmit: (o) => {
                let params = {
                    idx : o.idx,
                    phoneme : o.phoneme,
                    notation : o.mark
                }
                if( !params.notation || !(params.notation.trim()) ){
                    toast.warning("발음 표기를 입력해 주세요.")
                    return;
                }
                axios.post("/ai/notation_mod", params).then((res) => {
                    if( res.data.err == 0 ){
                        comp.doSearch()
                        comp.deSelect()
                    } else {
                        if( res.data.err_msg ) toast.error( res.data.err_msg )
                    }
                });
            },

            // doDelete:(idx)=>{
            //     let params = { idx:idx }
            //     if( confirm("삭제하시겠습니까?") == true ){
            //         axios.post("/ai/notation_del", params).then((res) => {
            //             if( res.data.err == 0 ){
            //                 comp.doSearch()
            //             } else {
            //                 if( res.data.err_msg ) toast.error( res.data.err_msg )
            //             }
            //         })
            //     }
            // },

        });

        onMounted(() => {
            comp.doSearch()
        });

        return { comp };
    }
}
</script>

<style lang="scss">
    @import "@/scss/_variables.scss";

    .bar {
        position:relative; height:20px; padding:10px 0px; border-top:1px solid #c8c8c8; margin:20px 20px 0;
        span {
            position:absolute; top:-10px; left:0; right:0; width:130px; margin:0 auto; text-align:center; background-color:#f9f9f9; color:#999;
        }
    }

    .notation-list {
        padding:0 20px 40px;
        .notation-item {
            position:relative; margin-bottom:5px; border-bottom:1px solid #c8c8c8; padding-bottom:5px;
            &::after {
                content:''; display:block; clear:both;
            }
            .phoneme, .notation {
                float:left; width:calc(50% - 50px);
            }
            .notation {
                margin-left:4px;
            }
            .reum-textbox {
                padding-top:0px; 
                input {
                    border-radius:0; text-align:center;
                }
            }

            .btn-box {
                text-align:right;
                .btn {
                    display:inline-block; width:40px; height:40px; border: 1px solid #ddd; border-radius: 50px;
                    padding: 3px 0px; color: #FFF; font-size:1.4rem; text-align:center;
                    &.btn-submit {
                        background-color:rgb(132, 196, 49);
                    }
                    &.btn-del {
                        background-color: rgb(255, 81, 81); margin-left:2px;
                    }
                }
            }
        }
    }


</style>